export default {
  "Sivut": "Sidor",
  "Ei luokiteltu": "Okategoriserad",
  "Viimeiset 8 viikkoa": "Senaste 8 veckorna",
  "Vie palautteet": "Exportera respons",
  "Ulkoasuasetukset": "Utseendeinställningar",
  "Logo": "Logotyp",
  "Väri": "Färg",
  "Logon tulee olla PNG-tiedosto, jonka tausta on läpinäkyvä.": "Logotypen måste vara en PNG-fil med transparent bakgrund.",
  "Ei logoa": "Ingen logotyp",
  "Valitse logo": "Välj logotyp",
  "Logon tulee olla PNG-tiedosto.": "Logotypen måste vara en PNG-fil.",
  "Tiedosto on liian suuri (max 5 MB).": "Filen är för stor (max 5 MB).",
  "Logon tausta tulee olla läpinäkyvä.": "Logotypens bakgrund måste vara transparent.",
  "Tiedostoa ei voitu lukea kuvana.": "Filen kunde inte läsas som en bild.",
  "Logon tallennus epäonnistui.": "Det gick inte att spara logotypen.",
  "Poista logo": "Ta bort logo",
  "Logon poistaminen epäonnistui.": "Det gick inte att ta bort logon.",
  "Näytön logo korvaa yrityksen logon tällä näytöllä. Kuvan ei tarvitse olla neliö.": "Logon ersätter företagets logo på denna skärm. Bilden behöver inte vara kvadratisk.",
  "Tehosteväriä käytetään sovelluksen painikkeissa, otsikoissa ja korostuksissa.": "Accentfärgen används för appens knappar, rubriker och accenter.",
  "Esikatselu": "Förhandsgranskning",
  "Esimerkki": "Exempel",
  "Painike": "Knapp",
  "Värin tallennus epäonnistui.": "Det gick inte att spara färgen.",
  "Pääkäyttäjät": "Huvudanvändare",
  "Vain pääkäyttäjät voivat lisätä tai poistaa toisia pääkäyttäjiä.": "Endast huvudanvändare kan lägga till eller ta bort andra huvudanvändare.",
  "Näytä loki": "Visa logg",
  "Lisää pääkäyttäjä": "Lägg till huvudanvändare",
  "Ei pääkäyttäjiä": "Inga huvudanvändare",
  "Et voi poistaa itseäsi pääkäyttäjistä": "Du kan inte ta bort dig själv från huvudanvändare",
  "Viimeistä pääkäyttäjää ei voi poistaa": "Den sista huvudanvändaren kan inte tas bort",
  "Poista pääkäyttäjistä": "Ta bort från huvudanvändare",
  confirm_remove_mainuser: "Är du säker på att du vill ta bort användaren {name} från huvudanvändare? Användaren blir kvar i systemet som en vanlig användare.",
  "Hae käyttäjää": "Sök användare",
  "Kirjoita nimi tai sähköposti": "Skriv namn eller e-post",
  "Ei tuloksia": "Inga resultat",
  "Lisää pääkäyttäjäksi": "Lägg till som huvudanvändare",
  "Pääkäyttäjän lisääminen epäonnistui": "Det gick inte att lägga till huvudanvändaren",
  "Pääkäyttäjien muutosloki": "Ändringslogg för huvudanvändare",
  "Ei merkintöjä": "Inga poster",
  "Toiminto": "Åtgärd",
  "Suoritti": "Utförd av",
  "Pääkäyttäjän oikeudet lisätty": "Huvudanvändarrättigheter tilldelade",
  "Pääkäyttäjän oikeudet poistettu": "Huvudanvändarrättigheter borttagna",

  "feedback_newview_info": "Vi förnyar feedbackhanteringen! Prova den nya vyn nedan. Det nya gränssnittet blir standard i framtiden.",
  "Uusi näkymä": "Ny vy",
  "Ohjeet": "Instruktioner",
  "Puhelinnumero": "Telefonnummer",
  "Pitkä vastaus": "Långt svar",
  "Lyhyt vastaus": "Kort svar",
  "Valitse yksi": "Välj en",
  "Takaisin": "Tillbaka",
  "Saapuneet / luokka": "Inkorg / kategori",
  "Vanha näkymä": "Gammal vy",
  "Päivitä": "Uppdatera",
  "Näytä valmiit": "Visa färdiga",
  "Tieto ei näy palautteen lähettäjälle": "Syns inte för den som skickat feedback",
  "Sisäinen otsikko": "Intern titel",
  "Ei valmiita palautteita": "Ingen färdig respons",
  "Ei saapuneita palautteita": "Ingen inkommen respons",
  "Ei käsittelyssä olevia palautteita": "Ingen respons under behandling",
  "Näytä infotv näytöillä": "Visa på Infotv-skärmar",
  "Ei käytössä": "Inte i bruk",
  "Lomake": "Formulär",
  "Käytä mukautettua lomaketta": "Använd anpassat formulär",
  "Poista palautetyyppi käytöstä ja tallenna muutokset muokataksesi lomakekenttiä": "Inaktivera feedbacktypen och spara ändringar för att redigera formulärfälten",
  "Sisältö": "Innehåll",
  "Asetukset": "Inställningar",
  "Lataa ja lisää": "Ladda upp och lägg till",
  "Näyttö": "Skärm",
  "Toissijainen sisältö (30%)": "Sekundärt innehåll (30%)",
  "Pääsisältö (70%)": "Huvudinnehåll (70%)",
  "Alatunnisteen tekstit": "Sidfotstexter",
  "Lisää teksti": "Lägg till text",
  "Näytöt": "Skärmar",
  "Ulkoasu": "Utseende",
  "Sää": "Väder",
  "Näytön sisällönhallinta": "Skärminnehållshantering",
  "Asettelu": "Layout",
  "Haluatko varmasti poistaa sisällön näytöltä?": "Är du säker på att du vill ta bort innehållet från skärmen?",
  "Jaettu asettelu (70% / 30%)": "Delad layout (70% / 30%)",
  "Koko leveys": "Full bredd",
  "Tumma tila": "Mörkt läge",
  "Näytä alatunniste": "Visa sidfot",
  "Sisällön näyttöaika (sekuntia)": "Innehållsvisningstid (sekunder)",
  "Valitse kirjastosta": "Välj från biblioteket",
  "Ei hakutuloksia": "Inga sökresultat",
  "Ei kuvia kirjastossa": "Inga bilder i biblioteket",
  "Lisää näytölle": "Lägg till på skärmen",
  "Virhe lisättäessä sisältöä": "Fel vid tillägg av innehåll",
  "kohdetta": "objekt",
  "Lisää": "Lägg till",
  "Lataa kuva": "Ladda upp bild",
  "Kirjastosta": "Från biblioteket",
  "Uutiset": "Nyheter",
  "Tapahtumat": "Händelser",
  "Lisää sisältöä yllä olevilla painikkeilla": "Lägg till innehåll med knapparna ovan",
  "aktiivista uutista.": "aktiva nyheter.",
  "Näytetään max 5 uusinta uutista": "Visar max 5 senaste nyheterna",
  "Ei aktiivisia uutisia": "Inga aktiva nyheter",
  "Ilmoittautuneet": "Anmälda",
  "permanent_pages_info": "Permanenta sidor visas i Piiri-appens meny som egna sektioner (till exempel med rubriken Vårt företag). Du kan skapa nya sektioner om du vill gruppera innehållet på permanenta sidor i separata ämnen som visas i menyn. En ny sektion visas i menyn när appen startas om eller webbläsarsidan uppdateras",
  "Osio": "Sektion",
  "Luo uusi osio": "Skapa ny sektion",
  "Pysyvät sivut": "Permanenta sidor",
  "Uusi kyselytyökalu": "Nytt enkätverktyg",
  "Lomakkeella on vastauksia. Muokkaus rajoitettu.": "Formuläret har svar. Redigering är begränsad.",
  "Huom: Lomaketta voi muokata rajoitetusti sen jälkeen kun siihen on tullut vastauksia.": "Obs: Formuläret kan endast redigeras i begränsad omfattning efter att svar har inkommit.",
  "surveyinfo1": "Vi förnyar våra enkäter. Du kan prova det nya enkätverktyget",
  "surveyinfo2": "Piiri-mobilappen måste uppdateras till den nya versionen (1.15.0) för att enkäter skapade med det nya enkätverktyget ska synas för användarna.",
  "Sinulla ei ole oikeuksia kaikkiin tämän julkaisun ryhmiin.": "Du har inte rättigheter till alla grupper i denna publikation.",
  "Voit tarkastella julkaisua, mutta et voi tehdä muutoksia.": "Du kan se publikationen, men du kan inte göra ändringar.",
  "Oletus": "Standard",
  "Vie kaaviot kuvana": "Exportera diagram som bild",
  "Suodattimet": "Filter",
  "Tyhjennä": "Töm",
  "Aikavyöhyke": "Tidszon",
  "Vastausvaihtoehto": "Svarsalternativ",
  "Lisää vaihtoehto": "Lägg till alternativ",
  "Tyhjä vaihtoehto": "Tomt alternativ",
  "Vaihtoehto": "Alternativ",
  "Vastausvaihtoehdot": "Svarsalternativ",
  "Haluatko varmasti poistaa vastausvaihtoehdon?": "Vill du verkligen ta bort svarsalternativet?",
  "vastausta": "svar",
  "Ei vastauksia": "Inga svar",
  "Kentällä ei ole otsikkoa": "Fältet har ingen rubrik",
  "Klikkaa muokataksesi kenttää": "Klicka för att redigera fältet",
  "Ohjeteksti (valinnainen)": "Hjälptext (valfritt)",
  "Päivämäärä": "Datum",
  "Pakollinen": "Obligatorisk",
  "Kentän otsikko": "Fältets rubrik",
  "Tietotyyppi": "Datatyp",
  "Vastausaika on pakollinen": "Svarstid är obligatorisk",
  "Monirivinen teksti": "Flerradig text",
  "Ei kysymyksiä. Lisää ensimmäinen kysymys vasemmalta.": "Inga frågor. Lägg till den första frågan från vänster.",
  "Monivalinta": "Flervalsfråga",
  "Valinta": "Val",
  "Valitse vähintään yksi ryhmä": "Välj minst en grupp",
  "Teksti": "Text",
  "Lisää kysymys": "Lägg till fråga",
  "Lomakkeen kentät": "Formulärfält",
  "Julkaise ryhmiin": "Publicera till grupper",
  "Kopioi kysely": "Kopiera förfrågan",

  "Tietoa Piiri-sovelluksesta": "Om Piiri-appen",
  "Vaadi lukukuittaus": "Kräv läsbekräftelse",
  "Selite (valinnainen)": "Beskrivning (valfritt)",
  "Teksti näytetään käyttäjille lukukuittauksen yhteydessä": "Texten visas för användarna i samband med läsbekräftelsen",
  "Jos nostatte versionumeroa, käyttäjiltä vaaditaan sisällölle uudelleen lukukuittaus": "Om ni höjer versionsnumret krävs en ny läsbekräftelse från användarna för innehållet",
  "Sivu": "Sida",
  "Lukukuittaus saatu": "Läsbekräftelse mottagen",
  "Ei lukukuittausta": "Ingen läsbekräftelse",
  "Lukukuittauksia ei ole käytössä": "Läsbekräftelser är inte aktiverade",
  "Versio": "Version",
  "Raportti": "Rapport",
  "Ryhmän ylläpitäjä näkee vain ylläpitämiensä ryhmien tiedostot": "Gruppadministratören kan endast se filerna för de grupper som de administrerar",
  "Muokkaa kansiota": "Redigera mapp",
  "Uusi kansio": "Ny mapp",
  "Uusi alikansio": "Ny undermapp",
  "tiedostoa": "filer",
  "Muokkaa": "Redigera",
  "Lukukuittaukset": "Läsbekräftelser",
  "Failed to submit acknowledgment. Please try again.": "Det gick inte att skicka bekräftelsen. Försök igen.",
  "Kuittaa luetuksi": "Kvittera",
  "Lukukuittaus": "Läsbekräftelse",
  "Lukukuittaus vaaditaan": "Läsbekräftelse krävs",
  "Olet kuitannut tämän luetuksi": "Du har bekräftat detta som läst",
  "Sisältö on päivittynyt viime kuittauksesi jälkeen. Kuittaa uudelleen.": "Innehållet har uppdaterats sedan din senaste bekräftelse. Bekräfta igen.",
  "Tämä sisältö vaatii lukukuittauksen.": "Detta innehåll kräver en läsbekräftelse.",
  "Your browser does not support the video tag.": "Din webbläsare stöder inte videotaggen.",
  "Avaa linkki": "Öppna länk",
  "Kaikki tiedostot": "Alla filer",
  "Kansio": "Mapp",
  "Avaa tiedosto": "Öppna filen",
  "Kansion nimi": "Mappnamn",
  "Järjestys": "Ordning",
  "Haluatko varmasti poistaa kansion?": "Är du säker på att du vill radera mappen?",
  "Anna kansion nimi": "Ange mappnamn",
  "Vie ilmoittautumiset": "Exportera anmälda",
  "Avainsanoilla voidaan luokitella ja suodattaa uutisia.": "Nyheter kan kategoriseras och filtreras med hjälp av nyckelord.",
  "Ryhmä on käytössä": "Gruppen är aktiv",
  "Ryhmä ei ole käytössä": "Gruppen är inte aktiv",
  "DisableGroupInfo": "En grupp kan markeras som inaktiv om den saknar:\n- administratör\n- diskussionskanal\n- Vårt företag-sida (eller annan namngiven permanent sida)\n\nSå här markerar du en använd grupp som inaktiv:\n- Ta bort gruppens administrationsrättigheter i användarhanteringen.\n- Markera de diskussionskanaler som är kopplade till gruppen som inaktiva.\n- Ta bort gruppens Vårt företag-sidor eller flytta dem till en annan grupp. Om den permanenta sidan syns för flera grupper, räcker det att ta bort synligheten för den grupp som ska tas bort.\n\nObservera!\nAnnat innehåll som skapats för gruppen (nyheter, evenemang, förfrågan, filer) finns kvar i Piiri även när gruppen tas bort ur bruk.",
  "Käyttäjä halitsee tietoa itse": "Användaren kontrollerar informationen själv",
  "Käyttäjän kielivalinta": "Användarens språkval",
  "Tiedoston maksimikoko on 10MB": "Den maximala filstorleken är 10 MB",
  "Peruuta": "Avbryt",
  "Avainsanat käytössä": "Nyckelord i bruk",
  "Uusi ryhmä": "Ny grupp",
  "Hae": "Sök",
  "Järjestä": "Sortera",
  "department-info": "Avdelningarnas användning är frivillig. Gruppindelningen av personalen i avdelningar syns endast i avsnittet 'Arbetar hos oss'. Om företaget grupperar personalen i avdelningar kan användarna söka kontaktuppgifter per avdelning.",
  "Oletusuutiskuva": "Standard nyhetsbild",
  "Julkaisuasetukset": "Publiceringsinställningar",
  "Oletusuutiskuvaa käytetään logon sijaan uutisissa mikäli uutisella ei ole omaa kuvaa.": "Standardbilden för nyheter används i stället för logotypen om nyheten inte har någon egen bild.",
  "Hae otsikolla": "Sök efter titel",
  "Kysymys julkaistaan heti": "Frågan publiceras omedelbart",
  "Tapahtuma julkaistaan julkaisuaikana": "Händelsen publiceras vid publiceringstidpunkten",
  "Nimi on pakollinen kaikilla kielillä": "Namn är obligatoriskt på alla språk",
  "Uusi osasto": "Ny avdelning",
  "Kaikki": "Alla",
  "Osastot": "Avdelningar",
  "Uusi ryhmä": "Ny grupp",
  "Ryhmän nimi": "Gruppens namn",
  "Oma tila": "Egen status",
  "Yhteiset liitteet": "Gemensamma bilagor",
  "attachment_lang_tip": "Gemensamma bilagor är synliga för alla, oavsett språkval. Bilagor med språkversioner är endast synliga för användare av det språkvalet.",
  "Käännös suoritettu. Varmista käännöksen oikeellisuus ennen tallentamista.": "Översättningen är klar. Kontrollera att översättningen är korrekt innan du sparar den.",
  "Suorita käännös": "Utför översättning",
  "Automaattinen käännös": "Automatisk översättning",
  "deepl_notice": "Tjänsten <a href='https://www.deepl.com/en/translator' target='_blank'> DeepL</a> används för att översätta innehållet. Observera att den översatta texten kommer att skickas till DeepLis servrar för bearbetning. Företaget är ansvarigt för att säkerställa att det översatta innehållet är korrekt och lämpligt. Verktyget är endast avsett för att översätta Piiris innehåll",
  "Haluatko varmasti poistaa käyttäjän? Toimintoa ei voi perua!": "Är du säker på att du vill ta radera användare? Åtgärden kan inte avbrytas!",
  "Jos haluat päivittää kuvan, poista ensin olemassa oleva kuva": "Om du vill uppdatera bilden, ta först bort den befintliga bilden.",
  "ryhmää": "grupper",
  "Push-ilmoitukset käytössä": "Skick push-notifikation",
  "Kansikuvat": "Omslagsbild",
  "Ei kuvia, näytetään logo": "Inga bilder, logo visas",
  "Lisää uusi kansikuva": "Lägg till en ny omslagsbild",
  "Enintään 5 kuvaa voidaan lisätä": "Högst 5 bilder kan läggas till",
  "Haluatko varmasti poistaa kuvan?": "Är du säker att du vill radera bilden?",
  "Kuvien suositeltu kuvasuhde on 16:9, esim. 1920x1080px": "Den rekommenderade bildförhållandet är 16:9, t.ex. 1920x1080px",
  "Kuvat näytetään kuvakarusellissa": "Bilderna visas i en bildkarusel",
  "Vastauksiin liitetään nimi automaattisesti": "Namnet kopplas automatiskt till svaren",
  "Kyselyyn voi vastata useita kertoja": "Man kan svara på förfrågan flera gånger",
  "Vastaukset kerätään anonyymisti": "Svaren samlas in anonymt",
  "Tätä asetusta ei voi muuttaa sen jälkeen kun kyselyyn on vastattu": "Denna inställning kan inte ändras efter att förfrågan har besvarats",
  "Salli useita vastauksia samalta käyttäjältä": "Tillåt flera svar från samma användare",
  "Palautteiden käsittelijäksi voidaan...": "Obs. Som responsehanterare kan väljas huvudanvändaren och gruppadministratör. Du kan lägga till gruppadministratörs rättigheter för en användare under Användare",
  "Kaikki muutokset kirjataan lokiin": "Alla ändringar som görs i responshanterare sparas i loggen. (Se loggen genom att klicka på ikonen till höger.)",
  "Valitse käsittelyoikeudet": "Välj hanteringsrättigheter",
  "Käsittelyoikeudet": "Hanteringsrättigheter",
  "Tallennus onnistui": "Sparad",
  "Aikaleima": "Tidsstämpel",
  "Suorittanut": "Utförd av",
  "Kohdekäyttäjä": "Målanvändare",
  "Loki": "Log",
  "Tapahtuma": "",
  "CategoryInfo": 'Klassificiering av respons har inte aktiverats. Skapa egna kategorier för olika responstyper genom att välja "Ny respons typ" och skriva instruktioner för responstypen.',
  "Palautetyypit": "Respons typ",
  "Palautetyypin nimi": "Namn för respons typ",
  "Valitse palautteen tyyppi": "Välj respons typ",
  "Otsikko on pakollinen kaikilla kielillä": "Rubrik är obligatorisk på alla språk",
  "Ohje palautteen lähettäjälle (esim. mitä tietoja ilmoitukseen tulee lisätä)": "Instruktioner för den som skickar respons (t.ex. vilken information som bör inkluderas i rapporten)",
  "Lyhyt kuvaus (milloin palautetyyppiä käytetään)": "Kort beskrivning (när ska typen användas)",
  "Uusi palautetyyppi": "Ny respons typ",
  "Palautteiden luokittelu": "Respons klassificering",
  "Haluatko varmasti ottaa palautteen käsittelyyn?": "Vill du säkert ta responsen i hantering?",
  "Käyttäjä on jättänyt yhteystiedot yhteydenottoa varten": "Användaren har lämnat kontaktinformation för kontaktändamål",
  "Palaute on käsitelty": "Responsen har behandlats",
  "Palauteilmoitukset": "Responshanterare",
  "Kirjoita viesti": "Skriv meddelande",
  "Sinä": "Du",
  "Voit lähettää yhden viestin vastauksena": "Du kan skicka ett meddelande som svar",
  "Haluatko varmasti lähettää viestin?": "Vill du säkert skicka meddelandet?",
  "Palautteet": "Responshistorik",
  "Näytä lähetetyt palautteet": "Visa skickad respons",
  "Piilota lähetetyt palautteet": "Göm skickad respons",
  "Haluatko jättää yhteystietosi henkilökohtaista vastausta varten?": "Vill du lämna dina kontaktuppgifter för personligt svar?",
  "Käsitelty": "Hanterad",
  "Avoin": "Öppen",
  "Voit lähettää palautteen lähettäjälle viestin tai vastauksen sen jälkeen, kun palaute on otettu käsittelyyn": "Du kan skicka ett meddelande eller svar till avsändaren efter att responsen har tagits i behandling.",
  "Tietoja": "Info",
  "Palautteen lähettäjä voi vastata lähettämääsi viestiin tai viesteihin niin kauan, kunnes palaute on merkitty käsitellyksi.": "Avsändaren kan svara på ditt meddelande eller meddelanden så länge som responsen inte har markerats som behandlad.",
  "Käyttäjä": "Användare",
  "Yhteystiedot": "Kontaktinformation",
  "Viestit": "Meddelande",
  "Käyttäjä ei ole jättänyt yhteystietoja": "Användaren har inte lämnat kontaktinformation",
  "Lähetä lisäkysymys tai vastus": "Skicka en fråga eller svar",
  "Vie vastaukset": "Exportera svar",
  "Päivitykset": "Uppdateringar",
  "Kutsu uudet käyttäjät": "Bjud in nya användare",
  "Lisää uusi palautteiden käsittelijä": "Lägg till ny responshanterare",
  "Ilmoitus sähköpostiin": "Via epost",
  "Push-viesti puhelimeen": "Push-meddelande",
  "Kutsu käyttäjiä": "Skicka inbjudan till användare",
  "Käytä viestipohjaa": "Använd meddelandemall på",
  "Kutsuohje": "Meddelandet under skickas via sms till de valda användare. Om du vill, kan du redigera meddelandet före.",
  "Varmista, että käyttäjien puhelinnumerot ovat oikein ennen viestin lähetystä.": "Se till att användarnas telefonnummer är korrekta innan du skickar ett meddelande.",
  "Kutsumattomia käyttäjiä ei löytynyt": "Inga objudna användare hittades",
  "Kutsu valitut käyttäjät": "Skicka inbjudan till de valda",
  "Lähetys käynnissä, odota...": "Sändning på gång, vänta...",
  "Lähetys on valmis": "Inbjudan has skickats",
  "Kutsu käyttäjälle": "Inbjudan till användaren ",
  "numeroon": "till numret",
  "epäonnistui": "misslyckades",
  "Päivitä lista": "Uppdatera listan",
  "Viesti on pakollinen": "Meddelandet är obligatorisk",
  "Kirjoita vastaus": "Skriv ditt svar",
  "Vastauksia": "Svar",
  "Tiedostomuoto ei ole tuettu. Tuettuja tiedostomutooja ovat ": "Filetypen stöds inte. Stödda filtyp är ",
  "Liitetiedosto": "Bilaga",
  "Halutessasi voi liittää liitetiedoston": "Du kan bifoga en fil om det behövs",
  "Halutessasi voit liittää mukaan kuvan tai pdf-tiedoston": "Du kan bifoga en bild eller pdf-fil vid behov",
  "Liite": "Bilaga",
  "Ladataan...": "Laddar...",
  "Vastausaika on päättynyt": "Svarstidet har gått ut",
  "Ei ilmoittautumisia": "Inga registreringar",
  "Voit lähettää viestin Ctrl Enter painikkeilla": "Du kan skicka meddelandet med Ctrl + Enter",
  "Omat keskustelut": "Egna diskussion",
  "Näytä keskustelukanavat": "Visa kanaler",
  "Yksityinen kanava": "Privat kanal",
  "Hallinnoit tätä kanavaa": "Du ansvarar för denna kanal",
  "Aloita uusi keskustelu": "Starta ny diskussion",
  "Miten palautteet käsitellään": "Hur hanteras respons",
  "Haku": "Sök",
  "Omat tiedot ja asetukset": "Egna uppgifter och inställningar",
  "Julkaisuaika on pakollinen": "Publiceringstid är obligatorisk",
  "Kuvaus...": "Beskrivning...",
  "Saapunut ...": "Anländ...",
  "Nimi puuttuu": "Namn fattas",
  "Haluatko varmasti poistaa tapahtuman?": "Vill du säkert radera evenemangen?",
  "Ylläpito": "Administration",
  "Etusivu": "Hem",
  "Hallinta": "Administration",
  "Muut": "Mera",
  "Omat tiedot": "Egna uppgifter",
  "Kirjaudu ulos": "Logga ut",
  "Lähetä": "Skicka",
  "Olet vastannut kyselyyn": "Du har svarat på förfrågan",
  "Kyselyt": "Förfrågan",
  "Vastausaika päättyy": "Svarstiden går ut",
  "Ei kyselyjä": "Inga förfrågan",
  "Uusi tiedosto lisätty": "Ny fil tillagd",
  "Yritys": "Företag",
  "Raahaa kuva tähän tai klikkaa tästä ja valitse kuva tiedostoista.": "Dra en bild hit eller välj en bild från filerna.",
  "Kuponki": "Kupong",
  "Otsikko": "Rubrik",
  "Kuvaus": "Beskrivning",
  "Etu julkaistaan heti": "Förmånen publiceras omedelbart",
  "Etu tallennetaan luonnoksena": "Förmånen sparas som förslag",
  "Julkaise": "Publicera",
  "Tarkista lomakkeen tiedot": "Granska blankettens uppgifter",
  "Poista": "Radera",
  "Tallenna": "Spara",
  "Tallenna lisätieto": "Spara tilläggsuppgift",
  "Henkilöstöedut": "Personalförmån",
  "Uusi etu": "Ny förmån",
  "Julkaistu": "Publicerad",
  "Keskustelukanavat": "Chat-kanaler",
  "Nimi": "Namn",
  "Kuva": "Bild",
  "Kanavan tyyppi": "Kanalens typ",
  "Yksityinen keskustelu": "Privat chat",
  "Ryhmäkeskustelu": "Grupp chat",
  "Kanavaa hallinnoivat": "Ansvarsperson på kanalen",
  "Käytössä": "Aktiv",
  "Kanava on käytössä": "Kanalen är aktiv",
  "Kanava ei ole käytössä": "Kanalen är inte aktiv",
  "Uusi kanava": "Ny kanal",
  "Aktiivinen": "Aktiv",
  "Klo": "Kl.",
  "klo": "kl.",
  "Ilmoittautuminen päättyy": "Registrering avslutas",
  "Ilmoittautumiset": "Registreringar",
  "Henkilö": "Person",
  "Ilmoitautumisaika": "Registreringstid",
  "Kommentti": "Kommentt",
  "Tapahtumat": "Evenemang",
  "Julkaise ryhmään": "Publicera till grupp",
  "Tapahtuman alkuaika": "Evenemangens starttid",
  "Tapahtuman päättymisaika": "Evenemangens sluttid",
  "Ilmoittautuminen": "Registrering",
  "Kommentti ilmoittautumisen yhteydessä": "Komment i sammanhang med registrering",
  "Tapahtuma julkaistaan heti": "Evenemanget publiceras genast",
  "Tapahtuma tallennetaan luonnoksena": "Evenemanget sparas som förslag",
  "Ryhmä on pakollinen": "Grupp är obligatorisk",
  "Otsikko ja teksti on pakollinen": "Rubrik och text är obligatorisk",
  "Alkuaika on pakollinen": "Starttid är obligatoris",
  "Tarkista päättymisaika": "Kolla sluttid",
  "Tarkista ilmoittautumisen päättymisaika": "Kolla registreringens sluttid",
  "Otsikko tai teksti puuttuu": "Rubrik eller text fattas",
  "Uusi tapahtuma": "Nytt evenemang",
  "Aika": "Tid",
  "Ryhmä": "Grupp",
  "Kysymykset & vastaukset": "Frågor & svar",
  "Kysymys": "Fråga",
  "Uusi kysymys": "Ny fråga",
  "Saapunut": "Anlände",
  "päivää sitten": "dagar sedan",
  "Käsittelyssä": "I hantering",
  "Otettu käsittelyyn": "I hantering",
  "Valmis": "Behandlad",
  "Palaute": "Respons",
  "Käyttäjä toivoo vastausta": "Användaren önskar på svar",
  "Käyttäjä ei toivo vastausta": "Användaren önskar inte svar",
  "Käsittely": "Hantering",
  "Ota käsittelyyn": "Ta i hantering",
  "Sisäinen lisätieto": "Intern tilläggsuppgift",
  "Sisäinen lisätieto ei näy palautteen lähettäjälle": "Den interna tilläggsuppgiften syns inte till responsens avsändare",
  "Kuittaa käsitellyksi": "Kvittera som behandlad",
  "Palautekanava": "Respons",
  "SUODATA": "FILTRERA",
  "Saapuneet": "Anländ",
  "Käsittely kesken": "Hantering på gång",
  "Valmiit": "Behandlade",
  "Saapunut tänään": "Anländ idag",
  "Lisää kuva klikkaamalla tai raahaamalla kuva tähän": "Dra en bild hit eller välj en bild från filerna.",
  "Julkaisuaika": "Publiceringstid",
  "Liitteet": "Bifoga",
  "Lisää uusi liitetiedosto": "Sätt till bifoga",
  "Voit lisätä sivulle liitteitä tallennuksen jälkeen": "Du kan bifoga fil efter att sidan har sparats",
  "Video": "Video",
  "Lisää uutiseen video": "Sätt till video",
  "Kysely": "Förfrågan",
  "Lisää julkaisuun kysymys": "Sätt till en förfråga till publicering",
  "Kyselyyn on vastattu eikä kysymyksiä voi enää muokata": "Förfrågan har svar och den kan inte redigeras",
  "Kysymykset": "Frågor",
  "Uusi monivalintakysymys": "Ny flervalsfråga",
  "Uusi avoin kysymys": "Ny öppen fråga",
  "Kirjoita kysymys": "Skriv fråga",
  "Lisää vastausvaihtoehto": "Sätt till svarsalternativ",
  "Kirjoita vastausvaihtoehto": "Skriv svarsalternativ",
  "Uutinen julkaistaan julkaisaikana": "Nyheten publiceras genast",
  "Uutinen tallennetaan luonnoksena": "Nyheten sparas som förslag",
  "Uutiset": "Nyheter",
  "Uusi uutinen": "Ny nyhet",
  "Näytä vastaukset": "Visa svar",
  "Julkaisupäivä": "Publiceringstid",
  "Meidän yritys": "Vårt företag",
  "Keskustelut": "Diskussion",
  "Valitse kuva": "Välj bild",
  "Lisää sivulle video": "Sätt till video",
  "Vimeo videon id": "Vimeo video id",
  "Sivu julkaistaan heti": "Sidan publiceras genast",
  "Sivu tallennetaan luonnoksena": "Sidan sparas som förslag",
  "Tiedostomuoto ei ole tuettu. Tuettuja tiedostomuotoja ovat jpeg sekä png.": "Filformaten stöds inte. Stödda filformat är jpeg och png.",
  "Uusi sivu": "Ny sida",
  "Lisää alasivu": "Sätt till undersida",
  "Yhteenveto": "Sammanfattning",
  "Vastaukset": "Svar",
  "Vastausaika": "Svartid",
  "Vastauksia": "Svar",
  "Otsikko ja kuvaus on pakollinen": "Rubrik och beskrivning är obligatorisk",
  "Päivämäärä on pakollinen": "Datum är obligarisk",
  "Kyselyssä ei ole yhtään kysymystä": "Förfrågan har inten fråga",
  "Tarkista kysymykset": "Kolla frågorna",
  "Otsikko tai kuvaus puuttuu": "Rubrik eller beskrivning fattas",
  "Haluatko varmasti poistaaa kyselyn ja kaikki sen vastaukset?": "Vill du säkert radera förfrågan och alla dens svar?",
  "Uusi kysely": "Ny förfråga",
  "Tiedosto": "Fil",
  "Linkki": "Länk",
  "Valitse uusi tiedosto": "Välj ny fil",
  "Tämä tieto on pakollinen": "Denna uppgift är obligatorisk",
  "Max 500 merkkiä": "Max 500 tecken",
  "Tiedosto julkaistaan heti": "Filen publiceras genast",
  "Tiedosto tallennetaan luonnoksena": "Filen sparas som förslag",
  "Tiedosto puuttuu": "Filen fattas",
  "Linkki puuttuu": "Länken fattas",
  "Tiedostot": "Filer",
  "Uusi tiedosto": "Ny fil",
  "Avaa": "Öppna",
  "Tyyppi": "Typ",
  "Miten palautteet käsitellään?": "Hur hanteras respons?",
  "Palauteasetukset": "Respons inställningar",
  "Palautteiden käsittelykäytäntö": "Hantering av respons",
  "Käyttäjät": "Användare",
  "Etunimi": "Förnamn",
  "Sukunimi": "Efternamn",
  "Puhelin": "Telefon",
  "Sähköposti": "E-post",
  "Työtehtävä": "Arbetsuppgift",
  "Näytä sähköposti kaikille": "Visa e-post till alla",
  "Näytä puhelinnumero kaikille": "Visa telefon till alla",
  "Ryhmät": "Grupp",
  "Käyttäjä on yrityksen pääkäyttäjä, jolla on oikeudet julkaista kaikkiin ryhmiin": "Användaren är företagets huvudanvändare, som har rättighet att publicera till alla grupper",
  "Ryhmän ylläpitäjä": "Gruppens administatör",
  "Suodata": "Filtrera",
  "Uusi käyttäjä": "Ny användare",
  "Näytä ryhmän ylläpitäjät": "Visa gruppens administratör",
  "Sähköposti": "E-post",
  "Kaikki käyttäjät": "Alla användare",
  "Yrityksen pääkäyttäjät": "FÖretagets huvudanvändare",
  "Näytä kuponki": "Visa kupong",
  "Sulje": "Stäng",
  "Kirjoita viestisi": "Skriv ditt meddelande",
  "Aloita keskustelu": "Starta diskussion",
  "Yksityiset keskustelut": "Privata diskussioner",
  "Ei kanavia": "Inga kanal",
  "Ryhmäkeskustelut": "Gruppdiskussioner",
  "Viesti poistettu": "Meddelandet har raderats",
  "Poista viesti": "Radera meddelandet",
  "Olet ilmoittautunut tapahtumaan": "Du har registrerat dig till evenemanget",
  "Peru ilmoittautuminen": "Dra tillbaka ditt registrering",
  "Et ole ilmoittautunut tapahtumaan": "Du har inte registrerat dig till evenemanget",
  "Ilmoittaudu mukaan": "Registrera dig",
  "Jätä palaute tai kysymys": "Lämna respons eller en fråga",
  "Kiitos, viesti lähetetty": "Tack, meddelandet har skickats",
  "Kirjoita palaute tai kysymys": "Skriv respons eller en fråga",
  "Haluan henkilökohtaisen vastauksen": "Jag vill ha ett personligt svar",
  "Anna sähköposti tai puhelinnumero": "Ge e-post eller telefon",
  "Anna sähköpostiosoite tai puhelinnumero": "Ge e-post eller telefon",
  "Tervetuloa Piiriin": "Välkommen till Piiri",
  "Käyttäjätunnus tai puhelinnumero": "Användarnamn eller telefonnummer",
  "Jatka": "Fortsätt",
  "Salasana": "Lösenord",
  "Kirjaudu sisään": "Logga in",
  "Pin koodi": "Pin kod",
  "Pin koodin saapumisessa voi kestää hetken.": "Det kan ta en stund för pin kooden att anlända.",
  "Kirjautuminen epäonnistui": "Kunde inte logga in",
  "Kirjautuminen epäonnistui, tarkista pin koodi": "Inloggning misslyckades, granska pin kod",
  "Kirjaudutaan ulos...": "Loggar ut...",
  "Uusimmat": "Senaste",
  "Meillä töissä": "Arbetar hos oss",
  "Piiri-artikkelit": "Piiri-artiklar",
  "Omat tiedot & asetukset": "Egna uppgifter & inställningar",
  "Tietoa Piiri-sovelluksesta": "Information om Piiri-appen",
  "Mikä on Piiri Kit?": "Var är Piiri Kit?",
  "Tietosuojaseloste": "Sekretesspolicy",
  "Töissä": "På jobbet",
  "Poissa töistä": "Borta från jobbet",
  "Anna avainsana kaikilla kielillä.": "Ange nyckelord på alla språk.",
  "Avainsana": "Nyckelord",
  "Haluatko varmasti poistaa avainsanan?": "Vill du verkligen ta bort nyckelordet?",
  "Muokkaa avainsanaa": "Redigera nyckelord",
  "Luo uusi avainsana": "Skapa nytt nyckelord",
  "Avainsanat": "Nyckelord",
  "Hae avainsanoja tai lisää uusi": "Sök nyckelord eller lägg till nytt",
  "Paina Enter luodaksesi uuden avainsanan": "Tryck Enter för att skapa ett nytt nyckelord",
  "Avainsanojen hallinta": "Hantering av nyckelord",
  "Uudistamme kyselyjä. Pääset kokeilemaan uutta kyselytyökalua": "Vi förnyar förfrågan. Du kan prova det nya verktyget",
  "tästä": "här",
  "Kyselyn vastaukset": "Svar på förfråga",
  "Viimeisin vastaus": "Senaste svaret",
  "Näytetään": "Visar",
  "Kyselyä ei löytynyt": "Förfrågan hittades inte",
  "Saat PIN-koodin tekstiviestillä mikäli puhelinnumerosi on järjestelmässämme. Syötä se alle.": "Du får PIN-koden via textmeddelande om ditt telefonnummer finns i vårt system. Ange det nedan.",
  "Jos et saanut PIN-koodia, tarkista että syötit puhelinnumerosi oikein.": "Om du inte fick PIN-koden, kontrollera att du angav ditt telefonnummer korrekt.",
  "Kirjoita hakusana": "Skriv ett sökord",
  "Hakusanan tulee olla vähintään 3 merkkiä pitkä": "Sökordet måste vara minst 3 tecken långt"
}
